import { useState, useEffect, useCallback } from "react";
import { Draggable } from "react-drag-reorder";
import { connect, useDispatch } from "react-redux";
import {
  updateAppPriority,
  getApps,
} from "../../../../action/masters/appActionCreator";
import {
  changePositionOnDrag,
  changeVisibilty,
  sortAlphabetically,
} from "../../../../common-functions/commonFunctions";
import { cloneDeep, baseURL } from "../../../../constants/commonConstants";
import { getAlertData } from "../../../../helper/sweet-alert";
import { IUpdateAppPriority, IAppData } from "../../../../models/master/apps";
import { setApps } from "../../../../store/slices/master/appSlice";
import LoaderSpinner from "../../../../common-components/loader";
import FloatingLabelDropDown from "../../../../common-components/floatingdropdown";
import {
  getColleges,
  getUserPageBlocks,
} from "../../../../action/common/commonActionCreator";
import { masterType } from "../../../../constants/masterTypes";
import {
  setColleges,
  setPageBlocks,
} from "../../../../store/slices/common/commonSlice";
import { UserRole } from "../../../../constants/RoleEnum";

const PriorityApps = (props: IUpdateAppPriority) => {
  const {
    updateAppPriority,
    getApps,
    apps,
    configUserRole,
    getColleges,
    colleges,
    getUserPageBlocks,
    pageBlocks,
    currentRole,
    currentCollege,
  } = props;
  const [filteredItems, setfilteredItems] = useState<any[]>([]);
  const [loader, setLoader] = useState(true);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [selectedCollege, setSelectedCollege] = useState<any>(null);
  const [selectedPageBlock, setSelectedPageBlock] = useState<any>(null);
  const dispatch = useDispatch();

  const saveChangedPos = async (currentPos: any, newPos: any) => {
    if (currentPos != newPos) {
      setLoader(true);
      let _items = changePositionOnDrag(filteredItems, currentPos, newPos);
      await setfilteredItems(_items);
      updateAppPriority(_items, setAlert);
    }
  };

  const ChangeVisibleOrNot = async (id: number, _displayOrNot: boolean) => {
    setLoader(true);
    let _items = changeVisibilty(id, _displayOrNot, filteredItems);
    setfilteredItems([..._items]);
    updateAppPriority(_items, setAlert);
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setLoader(false);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllApps = async (
    configUserRoleId: number,
    pageBlockId: number,
    collegeId?: number
  ) => {
    setLoader(true);
    try {
      await getApps(configUserRoleId, pageBlockId, collegeId);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (colleges && colleges?.length > 0) {
      const defaultCollegeId = colleges[0]?.id;
      setSelectedCollege(defaultCollegeId);
    } else {
      setSelectedCollege(currentCollege);
    }
    if (pageBlocks?.length > 0) {
      const defaultPageBlockId = pageBlocks[0]?.id;
      setSelectedPageBlock(defaultPageBlockId);
    }
  }, [colleges, pageBlocks]);

  useEffect(() => {
    if (selectedCollege && selectedPageBlock) {
      getAllApps(configUserRole, selectedPageBlock, selectedCollege);
    }
  }, [selectedCollege, selectedPageBlock]);

  useEffect(() => {
    apps && setfilteredItems(cloneDeep(apps));
  }, [apps]);

  useEffect(() => {
    if (currentRole == UserRole.SuperAdmin) {
      getColleges && getColleges();
    }
    getUserPageBlocks(configUserRole, masterType.app);
    return () => {
      dispatch(setApps([]));
      dispatch(setColleges([]));
      dispatch(setPageBlocks([]));
    };
  }, [configUserRole]);

  const onSelectionChange = useCallback((e: any) => {
    if (e.target.name === "college") {
      setSelectedCollege(e.target.value);
    } else if (e.target.name === "pageBlock") {
      setSelectedPageBlock(e.target.value);
    }
  }, []);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Apps</h2>
          <div className="side-filter d-flex justify-content-end w-50">
            {currentRole == UserRole.SuperAdmin && (
              <div className="col-md-6">
                <FloatingLabelDropDown
                  label="University Management"
                  placeholder=""
                  onChange={(e: any) => onSelectionChange(e)}
                  isMandatory={false}
                  value={selectedCollege}
                  name="college"
                  optionsList={sortAlphabetically(colleges)}
                  showClear={false}
                />
              </div>
            )}
            <div className="col-md-6">
              <FloatingLabelDropDown
                label="Page-Block"
                placeholder=""
                onChange={(e: any) => onSelectionChange(e)}
                isMandatory={false}
                value={selectedPageBlock}
                name="pageBlock"
                optionsList={sortAlphabetically(pageBlocks)}
                showClear={false}
              />
            </div>
          </div>
        </div>

        <ul className="d-flex gap-3 flex-wrap mt-28">
          {loader ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
                width: "100%",
              }}
            >
              <LoaderSpinner />
            </div>
          ) : filteredItems && filteredItems?.length > 0 ? (
            <>
              <Draggable
                onPosChange={async (currentPos, newPos) => {
                  await saveChangedPos(currentPos, newPos);
                }}
              >
                {filteredItems
                  .filter((item: IAppData) => item.displayOrNot)
                  .map((app: IAppData, index: number) => (
                    <li className="admin-card">
                      <div className="top">
                        <span className="handle">
                          <img src="/assets/images/drag.svg" />
                        </span>
                        <span className="counter">{app.priority}</span>
                        <div className="form-checkbox">
                          <input
                            type="checkbox"
                            checked={app.displayOrNot}
                            id={app.priority + "app"}
                            onChange={() => {
                              ChangeVisibleOrNot(
                                app.id ?? 0,
                                !app.displayOrNot
                              );
                            }}
                          />
                          <label htmlFor={app.priority + "app"}></label>
                        </div>
                      </div>
                      <div className="btm">
                        <div className="img">
                          <img
                            src={app.image ? baseURL + app.image : ""}
                            alt=""
                          />
                        </div>
                        <h2>{app.name}</h2>
                      </div>
                    </li>
                  ))}
              </Draggable>
              {filteredItems
                .filter((item: IAppData) => !item.displayOrNot)
                .map((app: IAppData, index: number) => (
                  <li className="admin-card">
                    <div className="top">
                      <span className="handle">
                        <img src="/assets/images/drag.svg" />
                      </span>
                      <span className="counter">{}</span>
                      <div className="form-checkbox">
                        <input
                          type="checkbox"
                          checked={app.displayOrNot}
                          id={app.priority + ""}
                          onChange={() => {
                            ChangeVisibleOrNot(app.id ?? 0, !app.displayOrNot);
                          }}
                        />
                        <label htmlFor={app.priority + ""}></label>
                      </div>
                    </div>
                    <div className="btm">
                      <div className="img">
                        <img
                          src={app.image ? baseURL + app.image : ""}
                          alt=""
                        />
                      </div>
                      <h2>{app.name}</h2>
                    </div>
                  </li>
                ))}
            </>
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  updateAppPriority: (data: any, callBack: Function) =>
    updateAppPriority(data, callBack),
  getApps: (configUserRole: number, pageBlockId: number, collegeId?: number) =>
    getApps(configUserRole, pageBlockId, collegeId),
  getColleges: () => getColleges(),
  getUserPageBlocks: (userType: number, masterType: string) =>
    getUserPageBlocks(userType, masterType),
};

function mapStateToProps(state: any) {
  return {
    apps: state.app.apps,
    colleges: state.common.colleges,
    pageBlocks: state.common.pageBlocks,
    currentRole: state.userDetails.userProfileData?.currentRole,
    currentCollege: state.userDetails.userProfileData?.currentCollege?.id,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PriorityApps);
